export default __webpack_public_path__ + "static/media/thumb-down.c2e8b6e2.svg";